import showToastNotification from '@/hooks/useShowToast'
import { trpc } from '@/utils/trpc'

export const useRemoveTeamMember = (onClose: () => void) => {
  const utils = trpc.useUtils()
  const { mutate: removeTeamMember, isPending: isRemovingTeamMember } = trpc.removeTeamMember.useMutation({
    onSuccess: async () => {
      showToastNotification('success', {
        message: 'Team Member Removed',
        description: 'The user has been removed from the team.',
      })
      onClose()
      await utils.getTeamMembers.invalidate()
    },
    onError: () => {
      showToastNotification('error', {
        message: 'Failed to Remove Member',
        description: "We couldn't remove this user. Please try again later.",
      })
    },
  })

  return { removeTeamMember, isRemovingTeamMember }
}
